import { AnalyticsParent } from "@repo/edtech-analytics";

import { LessonType } from "../../types";

export const LESSON_TO_ANALYTICS: Record<LessonType, AnalyticsParent | undefined> = {
  [ LessonType.Video ]: AnalyticsParent.Video,
  [ LessonType.Scorm ]: AnalyticsParent.Scorm,
  [ LessonType.Test ]: undefined,
  [ LessonType.Pdf ]: AnalyticsParent.Pdf,
  [ LessonType.Presentation ]: AnalyticsParent.PowerPoint,
  [ LessonType.Photo ]: AnalyticsParent.Jpeg,
  [ LessonType.Photo2 ]: AnalyticsParent.Jpeg,
  [ LessonType.Longread ]: AnalyticsParent.Longread,
  [ LessonType.Longread2 ]: AnalyticsParent.Longread,
  [ LessonType.Longread3 ]: AnalyticsParent.Longread,
  [ LessonType.Audio ]: AnalyticsParent.Audio,
  [ LessonType.Folder ]: AnalyticsParent.Folder,
};
